import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";

let _setBusy = null;

const BusyLoader = () => {
  const [busyIcon, setBusyIcon] = useState(false);

  useEffect(() => {
    _setBusy = setBusyIcon;
    return () => {
      _setBusy = null;
    };
  }, []);

  return (
    <div
      className="overlay"
      style={{
        background: "rgb(226 233 233 / 40%)",
        justifyContent: "center",
        position: "fixed",
        width: "100%",
        height: window.innerHeight - 10,
        zIndex: 9999,
        display: busyIcon ? "flex" : "none",
        alignItems: "center",
      }}>
      <CircularProgress
        style={{ color: "#4aa5dc", width: "50px", height: "50px" }}
      />
    </div>
  );
};

BusyLoader.showLoader = () => _setBusy?.(true);
BusyLoader.hideLoader = () => _setBusy?.(false);

export default BusyLoader;
